import { useCallback } from "react";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { useUpdateSiteControllerSettingBeds } from "../../../../model/beds24/use-case";

import type { SiteControllerSettingBeds24FormModel } from "../../../../model/beds24/type";

type Props = {
	viewModel: SiteControllerSettingBeds24FormModel["ViewModel"]; //
	onResetViewModel: () => void;
};

export const useSettingsSiteControllerBeds24 = ({ viewModel, onResetViewModel }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { onUpdate: _onUpdate } = useUpdateSiteControllerSettingBeds({ viewModel });
	const onUpdate = useCallback(async () => {
		showLoadingScreenCallback();

		const { errors } = await _onUpdate().finally(hideLoadingScreenCallback);

		if (!errors) {
			notifyUserEventInfo({
				title: "サイコン設定（Beds24）を更新しました",
			});
			onResetViewModel();
		}
	}, [_onUpdate, hideLoadingScreenCallback, onResetViewModel, showLoadingScreenCallback]);

	return {
		onUpdate,
	};
};
